export const citizenshipOptions = ["US"] as const;
